import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

import {
    MediaPicture,
    MediaQueryOption,
} from "@hermes/aphrodite/media-picture";

import { MeasureYourselfImageMedia } from "@hermes/api-model-product";

@Component({
    selector: "h-block-image",
    templateUrl: "./block-image.component.html",
    styleUrls: ["./block-image.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BlockImageComponent {
    public MEDIA_QUERIES_OPTIONS: MediaQueryOption[] = [
        {
            size: "medium",
            mediaQuery: "(min-width: 320px)",
            width: 300,
        },
    ];

    public mediaPicture!: MediaPicture;

    @Input({ required: true })
    public set blockMeasureYourself(
        blockMeasureYourself: MeasureYourselfImageMedia,
    ) {
        if (blockMeasureYourself.url) {
            this.mediaPicture = {
                desktopImage: blockMeasureYourself.url,
                mobileImage: blockMeasureYourself.url,
                imageAlt: blockMeasureYourself.alternate,
            };
        }
    }
}
